import { fork } from 'redux-saga/effects'
import error from './error'
import currency from './currency'
import dataIntegration from './dataIntegration'
import dataSource from './dataSource'
import documentStats from './documentStats'
import emailverification from './emailverification'
import expenseCategory from './expenseCategory'
import glCode from './glCode'
import globalSaga from './global'
import globalSearch from './globalSearch'
import jobCode from './jobCode'
import ledger from './ledger'
import ledgerFilter from './ledgerFilter'
import passwordReset from './passwordReset'
import paymentMethod from './paymentMethod'
import recentExpense from './recentExpense'
import report from './report'
import searchVendor from './searchVendor'
import session from './session'
import signup from './signup'
import stats from './stats'
import tags from './tags'
import uploadFile from './uploadFile'
import user from './user'
import userManagement from './userManagement'
import vendor from './vendor'
import vendors from './vendors'
import inbox from './inbox'
import workFlowStatus from './workFlowStatus'
import reconciliation from './reconciliation'
import workFlowStep from './workFlowStep'
import propertyName from './propertyName'
import unitNo from './unitNo'
import entity from './entity'
import department from './department'
import purchaseOrder from './purchaseOrder'

export default function* rootSaga() {
  yield fork(error)
  yield fork(currency)
  yield fork(dataIntegration)
  yield fork(dataSource)
  yield fork(documentStats)
  yield fork(emailverification)
  yield fork(expenseCategory)
  yield fork(glCode)
  yield fork(globalSaga)
  yield fork(globalSearch)
  yield fork(jobCode)
  yield fork(ledger)
  yield fork(ledgerFilter)
  yield fork(passwordReset)
  yield fork(paymentMethod)
  yield fork(recentExpense)
  yield fork(report)
  yield fork(searchVendor)
  yield fork(session)
  yield fork(signup)
  yield fork(stats)
  yield fork(tags)
  yield fork(uploadFile)
  yield fork(user)
  yield fork(userManagement)
  yield fork(vendor)
  yield fork(vendors)
  yield fork(inbox)
  yield fork(workFlowStatus)
  yield fork(reconciliation)
  yield fork(workFlowStep)
  yield fork(propertyName)
  yield fork(unitNo)
  yield fork(entity)
  yield fork(department)
  yield fork(purchaseOrder)
}
